import { render, staticRenderFns } from "./NotificationTypeEdit.vue?vue&type=template&id=53b0bc02&"
import script from "./NotificationTypeEdit.vue?vue&type=script&lang=js&"
export * from "./NotificationTypeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports